/* eslint-disable no-console */

/**
 * Logger
 *
 * A lightweight, reusable logger with per-module instances.
 */
export class Logger {
  private constructor(private readonly prefix: string) {}

  /** Factory method: create a logger for a module/feature */
  static for(moduleName: string): Logger {
    return new Logger(moduleName);
  }

  /** Internal helper to format log messages */
  private format(message: string): string {
    return `[${this.prefix}] ${message}`;
  }

  debug(message: string, ...data: unknown[]) {
    console.debug(this.format(message), ...data);
  }

  info(message: string, ...data: unknown[]) {
    console.info(this.format(message), ...data);
  }

  warn(message: string, ...data: unknown[]) {
    console.warn(this.format(message), ...data);
  }

  error(message: string, ...data: unknown[]) {
    console.error(this.format(message), ...data);
  }

  log(message: string, ...data: unknown[]) {
    console.log(this.format(message), ...data);
  }
}

// Pre-configured logger instance for the authentication module
export const AuthLogger = Logger.for('Auth');
